<template>
  <div class="bottom-bar-button" :class="[type,icon]">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: "primary"
    },
    icon: {
      type: String
    },
    
  },
  data() {
    return {};
  }
};
</script>

<style scoped>
.bottom-bar-button {
  display: block;
  flex: 1;
  /* text-align: center; */
  font-size: 16px;
  /* line-height: 52px; */
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.primary {
  background-color: #FFFFFF;
  color: #5292FF;
  border-top: 1px solid #F2F2F2;
  border-radius:8px 8px 0px 0px;
}
.normalBuy {
  background:rgba(116,179,250,1);
  border-radius:0px 8px 0px 0px;
  color: #ffffff;
}
.buy {
  background: #FF6886;
  color: #ffffff;
}
.share {
  background: #FFC44C;
  color: #ffffff;
}
.listen{
  background: #fff;
  color: #5292FF;
}

.cancel{
  border-top: 1px solid #DBDBDB;
  background: #fff;
  color: #5292FF;
}
</style>
